// Support page copy. Tone matches the landing page: formal and plain.
export const zh = {
  openMenu: '打开导航菜单',
  closeMenu: '关闭导航菜单',
  brand: '战篮 · 用户支持',
  serviceTabs: '服务类型',
  home: '返回官网',

  heading: '用户支持',
  intro: '登录战篮账号后，可在线申请发票或提交问题反馈。我们会人工处理，并通过邮件回复。',
  services: [
    { key: 'invoice', title: '申请发票', text: '选择已支付的订单，填写发票抬头与接收邮箱。' },
    { key: 'feedback', title: '问题反馈', text: '描述遇到的问题，可关联出现问题的云端战术。' }
  ],
  otherWays: '其他联系方式',
  helpCenter: '查看帮助中心',
  emailUs: '发送邮件至 support@basboard.com',

  login: '微信扫码登录',
  loginHint: '请使用战篮 App 中绑定的微信扫描二维码，登录同一账号。',
  showQr: '显示登录二维码',
  openLogin: '在新窗口打开微信登录',
  waiting: '请在手机微信中确认登录…',
  retry: '重新获取二维码',
  expired: '二维码已过期或失效，请重新获取。',
  mobileTitle: '请在战篮 App 中办理',
  mobileHint:
    '在手机上，请打开战篮 App，在「我的」页面进入「申请发票」或「建议与反馈」，无需扫码登录。也可以在电脑浏览器中打开本页面扫码登录。',
  openApp: '打开战篮 App',
  wechatAppHint: '请点击右上角「···」，选择「在浏览器中打开」，再打开战篮 App。',
  showQrAnyway: '仍在本机显示二维码',
  loginError: '无法加载微信登录，请重试。',
  handoffExpired: '登录链接已失效。请返回战篮 App 重新打开，或扫码登录。',
  afterLogin: '登录后将打开：',

  signedIn: '已登录',
  logout: '退出登录',
  member: '会员',
  normal: '普通用户',
  account: '账号 ID',

  invoice: '申请发票',
  feedback: '问题反馈',
  orderHeading: '选择要开票的订单',
  orderHint: '仅展示已支付且未退款的本人订单。每次申请选择一笔订单，我们会人工核实。',
  emptyOrders: '暂无可申请开票的订单。请确认当前登录的是购买时使用的账号；如有疑问，请提交问题反馈。',
  goFeedback: '提交问题反馈',
  loading: '正在加载…',
  loadMore: '加载更多订单',
  applied: '已提交申请',
  unknownAmount: '金额待核实',
  dateUnknown: '日期未记录',
  orderNumber: '订单号',
  channel: '购买渠道',
  product: '商品',
  titleType: '抬头类型',
  personal: '个人',
  company: '企业',
  title: '发票抬头',
  taxId: '纳税人识别号',
  taxIdHint: '15 至 20 位字母或数字。',

  description: '问题描述',
  descriptionHint: '请描述操作步骤、预期结果和实际情况，也可以补充设备型号与 App 版本。',
  relatedTactic: '关联战术（可选）',
  searchTactics: '按战术名称搜索',
  search: '搜索',
  noTactic: '不关联战术 / 一般问题',
  tacticHint: '可选择出现问题的云端战术。仅保存在设备上的本地战术，请在问题描述中说明。',
  noTactics: '未找到战术。可更换搜索词，或直接描述问题。',
  moreTactics: '加载更多战术',

  email: '接收邮箱',
  emailHint: '用于接收发票或问题回复，请确认填写正确。',
  consent: '我确认以上信息无误，并同意将其用于处理本次申请及邮件联系。',
  privacy: '隐私政策',
  invoiceSubmit: '提交开票申请',
  feedbackSubmit: '提交反馈',
  submitting: '正在提交…',
  selectOrder: '请先选择一笔订单。',
  error: '操作失败，请稍后重试。已填写的内容会保留。',
  authExpired: '登录已过期，请重新登录后继续提交。',
  unavailable: '用户支持服务暂不可用，请稍后再试。',
  networkError: '网络连接失败，请检查网络后重试。已填写的内容会保留。',
  reload: '重新加载',

  successTitle: '申请已提交',
  successHint: '我们会人工核实，并通过你填写的邮箱联系你。提交成功不代表已经开具发票。',
  receipt: '申请编号',
  keepReceipt: '请保存此编号，后续沟通时可用于查询。',
  another: '返回用户支持',
  serviceLink: '用户支持'
}
export const en = {
  openMenu: 'Open navigation menu',
  closeMenu: 'Close navigation menu',
  brand: 'Basboard · Support',
  serviceTabs: 'Request type',
  home: 'Back to website',

  heading: 'Support',
  intro:
    'Sign in with your Basboard account to request an invoice or send feedback. Every request is handled by our team and answered by email.',
  services: [
    { key: 'invoice', title: 'Request an invoice', text: 'Choose a paid order and enter the invoice name and email.' },
    { key: 'feedback', title: 'Send feedback', text: 'Describe the issue and, if relevant, link the cloud tactic involved.' }
  ],
  otherWays: 'Other ways to reach us',
  helpCenter: 'Browse the help center',
  emailUs: 'Email support@basboard.com',

  login: 'Sign in with WeChat',
  loginHint: 'Scan the QR code with the WeChat account linked to your Basboard account.',
  showQr: 'Show sign-in QR code',
  openLogin: 'Open WeChat sign-in in a new window',
  waiting: 'Confirm the sign-in in WeChat on your phone…',
  retry: 'Get a new QR code',
  expired: 'This QR code has expired or is no longer valid. Please get a new one.',
  mobileTitle: 'Continue in the Basboard app',
  mobileHint:
    'On your phone, open the Basboard app and go to Me → Request an invoice or Send feedback. No QR code is needed. You can also open this page on a computer and scan to sign in.',
  openApp: 'Open the Basboard app',
  wechatAppHint: 'Tap “···” in the top-right corner, choose “Open in browser”, then open the Basboard app.',
  showQrAnyway: 'Show the QR code on this device',
  loginError: 'Unable to load WeChat sign-in. Please retry.',
  handoffExpired: 'This sign-in link has expired. Reopen it from the Basboard app, or scan the QR code to sign in.',
  afterLogin: 'After signing in: ',

  signedIn: 'Signed in',
  logout: 'Sign out',
  member: 'Member',
  normal: 'Standard account',
  account: 'Account ID',

  invoice: 'Request an invoice',
  feedback: 'Send feedback',
  orderHeading: 'Choose your order',
  orderHint:
    'Only your paid, non-refunded orders are shown. Choose one order per request; we review each one manually.',
  emptyOrders:
    'No eligible orders were found. Check that you are signed in with the account used for the purchase, or send us feedback.',
  goFeedback: 'Send feedback instead',
  loading: 'Loading…',
  loadMore: 'Load more orders',
  applied: 'Request received',
  unknownAmount: 'Amount to be verified',
  dateUnknown: 'Date unavailable',
  orderNumber: 'Order',
  channel: 'Channel',
  product: 'Product',
  titleType: 'Invoice type',
  personal: 'Individual',
  company: 'Company',
  title: 'Invoice name',
  taxId: 'Tax identification number',
  taxIdHint: '15 to 20 letters or digits.',

  description: 'Describe the issue',
  descriptionHint:
    'Include the steps, the expected result and what actually happened. Your device and app version also help.',
  relatedTactic: 'Related tactic (optional)',
  searchTactics: 'Search by tactic name',
  search: 'Search',
  noTactic: 'No tactic / General issue',
  tacticHint: 'Choose the cloud tactic involved. For a tactic stored only on your device, describe it in the issue.',
  noTactics: 'No tactics found. Try another search or describe the issue without one.',
  moreTactics: 'Load more tactics',

  email: 'Email address',
  emailHint: 'We will send the invoice or our reply here. Please check the address.',
  consent: 'I confirm these details and agree to their use for this request and an email reply.',
  privacy: 'Privacy policy',
  invoiceSubmit: 'Submit invoice request',
  feedbackSubmit: 'Send feedback',
  submitting: 'Submitting…',
  selectOrder: 'Choose an order first.',
  error: 'Something went wrong. Please retry; your form has been kept.',
  authExpired: 'Your sign-in expired. Please sign in again to continue.',
  unavailable: 'Support is temporarily unavailable. Please try again later.',
  networkError: 'Could not connect. Check your network and try again; your form has been kept.',
  reload: 'Reload',

  successTitle: 'Request submitted',
  successHint:
    'We will review it and contact you by email. A submitted request does not mean an invoice has been issued.',
  receipt: 'Request ID',
  keepReceipt: 'Keep this ID; it helps us find your request if you contact us.',
  another: 'Back to support',
  serviceLink: 'Support'
}
